<template>
  <vuestic-modal :large="true" ref="detalle">
    <div slot="title">Detalle Producto</div>
    <table class="table table-striped table-success table-bordered">
      <thead>
      <tr>
        <th>Codigo</th>
        <th>Sucursal</th>
        <th>Stock</th>
        <th>Stock Minimo</th>
        <th>Stock Máximo</th>
        <th>A Comprar</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in detalleProducto" :key="index">
        <td>{{item.codigo}}</td>
        <td>{{printSucursal(item)}}</td>
        <td>{{item.stock}}</td>
        <td>{{item.stock_minimo}}</td>
        <td>{{item.stock_maximo}}</td>
        <td>{{item.cantidad_a_comprar}}</td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </vuestic-modal>
</template>

<script>
  import VuesticModal from "../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal";
  import {mapGetters} from "vuex";

  export default {
    name: "DetalleProductoSugerido",
    components: {VuesticModal},
    computed: {
      ...mapGetters({
        detalleProducto: "sugeridoCompra/detalleProducto"
      })
    },
    props: {
      producto: {}
    },
    methods: {
      openModal() {
        this.$refs.detalle.open()
        this.$store.dispatch("sugeridoCompra/getDetalle", this.producto.item)
      },
      printSucursal(item) {
        return this.$store.getters.sucursal(item.sucursal_id).nombre
      }
    }
  }
</script>

<style scoped>

</style>
